import z from 'zod';

export const surveyAnalysisSchema = z
  .object({
    summary: z
      .string()
      .describe(
        "One-sentence summary contextualizing the respondent's answers in relation to the survey questions",
      ),
    problemCategory: z.string().describe('the most fitting problem category'),
    recommendations: z.string().describe('your action recommendation'),
    sentiment: z
      .enum(['positive', 'negative', 'neutral'])
      .describe(
        'the overall sentiment of the answers: positive, negative or neutral',
      ),
    is_spam: z
      .boolean()
      .describe(
        "If the survey contains multiple nonsensical or irrelevant answers, or if there's a clear pattern of automated responses, this should be true. Otherwise, it should be false to avoid false positives.",
      ),
  })
  .describe(
    'An object containing the analysis of the survey results. This is the output of the survey analysis function.',
  );

